import { useState } from "react";
import { Menu, X, MessageCircle, Languages } from "lucide-react";
import { BRAND, NAV_LINKS, waLink, MESSAGES } from "@/data/site";
import { useLang } from "@/i18n";

const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`flex items-center rounded-full border border-[#D7B594] bg-white p-0.5 ${className}`} data-testid="lang-toggle">
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors duration-200 ${lang === "en" ? "bg-[#4A362E] text-white" : "text-[#5D4037]"}`}
      >
        EN
      </button>
      <button
        data-testid="lang-ta"
        onClick={() => setLang("ta")}
        className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors duration-200 ${lang === "ta" ? "bg-[#4A362E] text-white" : "text-[#5D4037]"} flex items-center gap-1`}
      >
        <Languages className="h-3 w-3" /> தமிழ்
      </button>
    </div>
  );
};

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const t = useLang().t;

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 border-b border-[#EFEBE4] bg-[#FDFBF7]/85 backdrop-blur-xl"
    >
      <div className="container-site flex h-16 sm:h-20 items-center justify-between gap-4">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img
            src={BRAND.logo}
            alt="Disign Digital logo"
            className="h-9 w-9 sm:h-10 sm:w-10 rounded-full object-cover border border-[#EFEBE4]"
          />
          <span className="font-heading text-lg sm:text-xl font-bold text-[#3E2723] lowercase tracking-tight">
            designdigital
          </span>
        </a>

        <nav className="hidden xl:flex items-center gap-4 2xl:gap-6" data-testid="nav-links">
          {NAV_LINKS.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="whitespace-nowrap text-[13px] 2xl:text-sm font-medium text-[#5D4037] transition-colors duration-200 hover:text-[#3E2723]"
            >
              {t.nav.links[i]}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <LangToggle />
          <a href="#contact" data-testid="nav-cta-get-website" className="btn-primary hidden sm:inline-flex !py-2.5 whitespace-nowrap">
            {t.nav.cta}
          </a>
          <button
            data-testid="nav-hamburger"
            onClick={() => setOpen(!open)}
            className="xl:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#EFEBE4] bg-white text-[#3E2723]"
            aria-label="Open menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="xl:hidden border-t border-[#EFEBE4] bg-[#FDFBF7]">
          <div className="container-site flex flex-col gap-1 py-4">
            {NAV_LINKS.map((link, i) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-mobile-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="rounded-xl px-4 py-3 text-base font-medium text-[#3E2723] transition-colors duration-200 hover:bg-[#F5F2EB]"
              >
                {t.nav.links[i]}
              </a>
            ))}
            <a
              href={waLink(MESSAGES.home)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-mobile-whatsapp"
              className="btn-whatsapp mt-2"
            >
              <MessageCircle className="h-4 w-4" /> {t.nav.whatsapp}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
